import { render, staticRenderFns } from "./SupplierManagement.vue?vue&type=template&id=6d80514a&"
import script from "./SupplierManagement.vue?vue&type=script&lang=js&"
export * from "./SupplierManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports